var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-4"},[_c('text-input',{attrs:{"value":_vm.secondaryScraper.scraper_payload},on:{"input":_vm.updateScraperPayload}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }